import { render, staticRenderFns } from "./m_chinese_Culture_Video_Exhibition.vue?vue&type=template&id=41ecebff&scoped=true"
import script from "./m_chinese_Culture_Video_Exhibition.vue?vue&type=script&lang=js"
export * from "./m_chinese_Culture_Video_Exhibition.vue?vue&type=script&lang=js"
import style0 from "./m_chinese_Culture_Video_Exhibition.vue?vue&type=style&index=0&id=41ecebff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ecebff",
  null
  
)

export default component.exports